import React from 'react';
export const SizeContext = React.createContext(
    {
        width: 1000,
        height: 1000
    }
  );